/* eslint-disable import/no-anonymous-default-export */
import service from './service';
import serviceTwo from './serviceTwo';
import { UrlBuilder } from './url-builder';

export const adminCompanies = async (companyId, name, page, pageSize) => {
  const builder = new UrlBuilder(`/admin/companies`);
  builder.add('companyId', companyId);
  builder.add('name', name);
  builder.add('page', page);
  builder.add('pageSize', pageSize);
  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const adminCompaniesForReport = async () => {
  const builder = new UrlBuilder(`/admin/companies`);

  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const partnerCompanies = async (partnerId, companyId, name, page, pageSize) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/companies`);
  builder.add('companyId', companyId);
  builder.add('name', name);
  builder.add('page', page);
  builder.add('pageSize', pageSize);
  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const partnerCompaniesAll = async (partnerId, companyId) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/companies`);
  builder.add('companyId', companyId);

  builder.add('mode', 'ALL');
  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const list = async (filter, page, pageSize) => {
  const builder = new UrlBuilder(`/companies`);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByParent = async (parentId, filter, page, pageSize) => {
  const builder = new UrlBuilder(`/parents/${parentId}/companies`);
  builder.add('companyId', filter.companyId);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllByCompany = async (companyId) => {
  if (!companyId) return [];

  const response = await service.get(`/companies/${companyId}/companies?mode=ALL`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getCompany = async (companyId) => {
  if (!companyId) return undefined;

  const response = await service.get(`/companies/${companyId}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const updateCompany = async (companyId, company) => {
  if (!companyId) return undefined;

  // const response = await service.put(`/companies/${company._id}`, company);

  // const response = await service.put(
  //   `/partners/${company?.partnerId}/company/${company?._id}`,
  //   company
  // );

  const response = await service.post(`/company/${companyId}/update`, company);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return response.data;
};

export const listUserRoles = async (companyId, page, pageSize) => {
  const response = await service.get(
    `/companies/${companyId}/roles?page=${page ?? 0}&pageSize=${pageSize ?? 10}&isDesktop=true`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllUsers = async (companyId) => {
  const response = await service.get(`/companies/${companyId}/roles?mode=ALL&isDesktop=true`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listOfCompanyUser = async (partnerId, companyId) => {
  const response = await service.get(`/partners/${partnerId}/companies/${companyId}/users`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByPartner = async (
  partnerId,
  // nameFilter,
  page,
  pageSize
) => {
  if (!partnerId) return [];

  const builder = new UrlBuilder(`/partners/${partnerId}/companies`);
  // builder.add('name', nameFilter);
  builder.add('page', page);
  builder.add('pageSize', pageSize ?? 10);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listUsersByPartner = async (partnerId, companyId, name, page, pageSize) => {
  if (!partnerId) return [];

  const builder = new UrlBuilder(`/partners/${partnerId}/companies/${companyId}/users`);

  builder.add('name', name);
  builder.add('page', page);
  builder.add('pageSize', pageSize ?? 10);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listUsersByParent = async (parentId, { filter }, page, pageSize) => {
  if (!parentId) return [];

  const builder = new UrlBuilder(`/companies/${parentId}/companies/all/users`);

  builder.add('companyId', filter.companyId);
  builder.add('page', page);
  builder.add('pageSize', pageSize ?? 10);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

const inviteUser = async (companyId, form) => {
  const response = await service.post(`/companies/${companyId}/invitations`, form);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

// const inviteFriend = async (form) => {
//   const response = await service.post(`/invitations/invite-friend`, form);

//   if (response.status === 200) {
//     return response.data;
//   }

//   return undefined;
// };

const inviteFriend = async () => {
  const response = await service.get(`/invitations/invite-friend`);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

const inviteCompany = async (companyId, form) => {
  const response = await service.post(`/companies/${companyId}/companies`, form);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

const countByPartner = async (partnerId, filter) => {
  if (!partnerId) return 0;

  const builder = new UrlBuilder(`/partners/${partnerId}/companies/count`);
  builder.add('companyId', filter?.companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

const countByAdmin = async (filter) => {
  const builder = new UrlBuilder(`/admin/companies/count`);
  builder.add('companyId', filter?.companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

const countByParent = async (parentId, filter) => {
  if (!parentId) return 0;

  const builder = new UrlBuilder(`/parents/${parentId}/companies/count`);
  builder.add('companyId', filter?.companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

const partnerListCompanyUsers = async (partnerId, companyId, roles, page, pageSize) => {
  if (!partnerId) return [];

  const builder = new UrlBuilder(`/partners/${partnerId}/companies/${companyId}/users`);
  builder.add('companyId', companyId);
  builder.add('roles', roles);
  builder.add('page', page);
  builder.add('PageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

const listCompanyUsers = async (companyId, roles, page, pageSize) => {
  const builder = new UrlBuilder(`/companies/${companyId}/users`);
  builder.add('roles', roles);
  builder.add('includeRole', true);
  builder.add('page', page);
  builder.add('PageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

const removeUserFromCompany = async (companyId, userId, roleId) => {
  const builder = new UrlBuilder(`/companies/${companyId}/users/${userId}`);
  builder.add('roleId', roleId);

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const deleteMyCompany = async () => {
  const builder = new UrlBuilder(`/user/delete-account`);

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const updateContactInfo = async (payload) => {
  const response = await serviceTwo.postTwo(`/auth/update-contact-details`, payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const suspendCompany = async (payload) => {
  const builder = new UrlBuilder(`/company/toggle-suspension`);

  const response = await serviceTwo.postTwo(builder.toString(), payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const companyFilterList = async (payload) => {
  const builder = new UrlBuilder(`/company/filter-list`);

  const response = await serviceTwo.postTwo(builder.toString(), payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export default {
  adminCompanies,
  partnerCompanies,
  listUserRoles,
  listUsersByPartner,
  listUsersByParent,
  list,
  listByParent,
  listAllByCompany,
  listByPartner,
  getCompany,
  updateCompany,
  inviteUser,
  inviteCompany,
  countByPartner,
  countByParent,
  partnerListCompanyUsers,
  listCompanyUsers,
  listOfCompanyUser,
  removeUserFromCompany,
  deleteMyCompany,
  countByAdmin,
  inviteFriend,
  listAllUsers,
  updateContactInfo,
  suspendCompany,
  companyFilterList,
};
